import { render } from "./DocCategory.vue?vue&type=template&id=82e686de&scoped=true&ts=true"
import script from "./DocCategory.vue?vue&type=script&lang=ts"
export * from "./DocCategory.vue?vue&type=script&lang=ts"

import "./DocCategory.vue?vue&type=style&index=0&id=82e686de&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82e686de"]])

export default __exports__